import { api } from './api';

export interface CheckUserResponse {
  success: boolean;
  data: {
    exists: boolean;
    phone: string;
  };
}

export interface RequestOTPResponse {
  success: boolean;
  message: string;
  data: {
    phone: string;
    expiresIn: number;
  };
}

export interface AuthResponse {
  success: boolean;
  message: string;
  data: {
    accessToken: string;
    refreshToken: string;
    user: {
      id: string;
      phone: string;
      name: string;
      role: string;
      isPhoneVerified: boolean;
    };
  };
}

export interface ErrorResponse {
  success: false;
  message: string;
  code?: string;
}

const whatsappAuthService = {
  checkUser: async (phone: string): Promise<CheckUserResponse> => {
    const response = await api.get('/whatsapp-auth/check-user', {
      params: { phone }
    });
    return response.data;
  },

  requestOTP: async (phone: string, name?: string): Promise<RequestOTPResponse> => {
    const response = await api.post('/whatsapp-auth/request-otp', {
      phone,
      name
    });
    return response.data;
  },

  verifyAndRegister: async (phone: string, otp: string, name: string): Promise<AuthResponse> => {
    const response = await api.post('/whatsapp-auth/verify-register', {
      phone,
      otp,
      name
    });
    return response.data;
  },

  login: async (phone: string, otp: string): Promise<AuthResponse> => {
    const response = await api.post('/whatsapp-auth/login', {
      phone,
      otp
    });
    return response.data;
  },

  storeTokens: (accessToken: string, refreshToken: string) => {
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
  },

  getAccessToken: (): string | null => {
    return localStorage.getItem('accessToken');
  },

  getRefreshToken: (): string | null => {
    return localStorage.getItem('refreshToken');
  },

  clearTokens: () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
  }
};

export default whatsappAuthService;
